import styled from "styled-components";

export const CircleChartWrapper = styled.div`
  width: 0;  // for responsive container bug
  flex: 1;
`;

export const LoadingBox = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
